import React from 'react';
import {
  TrendingUp,
  BarChart3,
  Landmark,
  HandCoins,
  Building2,
  ArrowRight,
} from 'lucide-react';
import { services } from '../data/mock';

const iconMap = {
  TrendingUp,
  BarChart3,
  Landmark,
  HandCoins,
  Building2,
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-12 h-0.5 bg-burgundy" />
            <span className="text-burgundy text-sm tracking-widest uppercase font-medium">
              What We Do
            </span>
            <div className="w-12 h-0.5 bg-burgundy" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-6">
            Our Core Services
          </h2>
          <p className="text-slate text-lg max-w-2xl mx-auto">
            Comprehensive advisory solutions tailored to drive sustainable growth
            and unlock capital for your business.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group p-8 bg-white border border-slate/10 hover:border-burgundy/30 transition-all duration-500 hover:shadow-xl hover:shadow-burgundy/5 relative overflow-hidden"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                {/* Top Accent Line */}
                <div className="absolute top-0 left-0 w-full h-1 bg-burgundy transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />

                {/* Icon */}
                <div className="w-14 h-14 bg-burgundy/5 flex items-center justify-center mb-6 group-hover:bg-burgundy transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent
                      className="text-burgundy group-hover:text-ivory transition-colors duration-300"
                      size={28}
                    />
                  )}
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-charcoal mb-4 group-hover:text-burgundy transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-slate leading-relaxed mb-6">
                  {service.description}
                </p>

                {/* Learn More Link */}
                <a
                  href="#contact"
                  className="inline-flex items-center gap-2 text-burgundy font-medium opacity-0 group-hover:opacity-100 transition-all duration-300 hover:gap-3"
                >
                  Learn More
                  <ArrowRight size={16} />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
